module.exports = __webpack_public_path__ + "static/media/snapchat.986d35d2.svg";